export enum EmailType {
    REPORT_BATCH_FAST_PAYMENT = 'reportBatchFastPayment',
    TRACKING = 'tracking',
    REPORT_BATCH_DELAYED_CARGOS = 'reportBatchDelayedCargos',
    ACCOUNTING = 'accounting',
    APPLICATIONS = 'applications',
    DELETE_CARGO_NOTIFICATION = 'deleteCargoNotification',
    CARGO_IMPORT = 'cargoImport',
    CARGO_EXPORT = 'cargoExport',
    GENERATE_MANIFEST = 'generateManifest',
    SEND_NOTIFICATION_PUSH_FROM_TRACKING = 'sendNotificationPushFromTracking',
    CONFIRMED_LICENSE_PLATE = 'confirmedLicensePlate',
}